module.exports = __webpack_public_path__ + "img/bci-basics-logo@2x.64d38ec2.png";